import { FormControl, FormHelperText, InputLabel, Select } from '@mui/material';
import * as React from 'react';
import { ValidatorComponent } from 'react-material-ui-form-validator';

export class SelectValidator extends ValidatorComponent {
	getErrorText() {
		const { isValid } = this.state;
		if (isValid) return null;
		return <FormHelperText>{this.getErrorMessage()}</FormHelperText>;
	}
	renderValidatorComponent() {
		const { value, onChange, options, label, className, fullWidth, disabled, margin } = this.props;
		return (
			<FormControl
				className={className}
				fullWidth={fullWidth}
				margin={margin}
				error={!this.state.isValid}
				disabled={disabled}
				variant="standard"
			>
				<InputLabel>{label}</InputLabel>
				<Select native value={value} onChange={onChange} variant="standard">
					{options.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</Select>
				{this.getErrorText()}
			</FormControl>
		);
	}
}
